import React, { useEffect } from 'react';
import { Row, Button, Divider } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  useFailedReceipts,
  useSignFailedReceipts,
} from 'RKSV/hooks/failedreceipts';
import { handleErrorNotification } from 'Common/utils';
import LogTable from './views/LogTable';

const FailedReceiptsContainer = () => {
  const { data, error, isLoading } = useFailedReceipts();
  const signedFailedReceiptsMutation = useSignFailedReceipts();
  const intl = useIntl();
  useEffect(() => {
    if (error) {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    }
  }, [error]);

  return (
    <>
      <Row justify="end">
        <Button
          type="primary"
          disabled={data !== undefined && data.length === 0}
          onClick={() => signedFailedReceiptsMutation.mutate()}
        >
          <FormattedMessage defaultMessage="Sign" />
        </Button>
      </Row>
      <Divider css="margin: 14px 0" />
      <LogTable
        receipts={data !== undefined ? data : []}
        loading={isLoading}
        showDownload={false}
      />
    </>
  );
};
export default FailedReceiptsContainer;
